import { combineReducers } from '@reduxjs/toolkit';

import authReducer from './authReducer';
import baseApi from '../../services/api/base';
import infiniteScrollReducer from './infiniteScrollReducer';
import userModalReducer from './userModalReducer';
import mailerLayoutReducer from './mailerLayoutReducer';
import nfeProcessingReducer from './nfeProcessingReducer';
import fileDownloadsReducer from './fileDownloadsReducer';
import sendInvoiceModalReducer from './sendInvoiceModalReducer';
import productKeyReducer from './productsReducer';
import meteorologyFieldsLayoutReducer from './meteorologyFieldsLayoutReducer';
import weatherLayoutReducer from './weatherLayoutReducer';
import sidebarsReducer from './sidebarsReducer';
import meteorologyFieldsControlPanelReducer from './meteorologyFieldsControlPanelReducer';
import meteorologyFieldsComparatorControlPanelReducer from './meteorologyFieldsComparatorControlPanelReducer';
import meteorologyFieldsClassicComparatorReducer from './meteorologyFieldsClassicComparatorControlPanelReducer';
import savePreferencesModalReducer from './savePreferencesModalReducer';
import meteorologyFieldsObservedDataControlPanelReducer
  from './meteorologyFieldsObservedDataControlPanelReducer';
import saveComparatorPreferencesModalReducer from './saveComparatorPreferencesModalReducer';
import imagesRowSizeReducer from './imagesRowSizeReducer';
import flexUploadLayoutReducer from './fluxUploadLayoutReducer';
import fluxPersonalizedLayoutReducer from './fluxPersonalizedLayoutReducer';
import fluxAutomaticControlPanelReducer from './fluxAutomaticControlPanelReducer';
import fluxAutomaticLayoutReducer from './fluxAutomaticLayoutReducer';
import fluxUploadFormReducer from './fluxUploadFormReducer';
import verifyZipFileModalReducer from './verifyZipFileModalReducer';
import fluxPersonalizedFormReducer from './fluxPersonalizedFormReducer';
import fluxAutomaticPreferencesModalReducer from './fluxAutomaticPreferencesModalReducer';
import synopticChartsReducer from './synopticChartsReducer';
import meteorologyWeatherSeasonalForecastControlPanelReducer
  from './meteorologyWeatherSeasonalForecastControlPanelReducer';
import meteorologyWeatherComparatorControlPanelReducer from './meteorologyWeatherComparatorControlPanelReducer';
import agroLayoutReducer from './agroLayoutReducer';
import meteorologyAgroWBCultureReducer from './meteorologyAgroWBCultureReducer';
import meteorologyAgroWBSequentialMapsReducer from './meteorologyAgroWBSequentialMapsReducer';
import meteorologyAgroWBSequentialDVReducer from './meteorologyAgroWBSequentialDVReducer';
import meteorologyAgroGroupLocationFeedbackReducer from './meteorologyAgroGroupLocationFeedbackReducer';
import meteorologyFieldsTrackingForecastControlPanelReducer from './meteorologyFieldsTrackingForecastControlPanelReducer';
import meteorologyFieldsGroupLocationFeedbackReducer from './meteorologyFieldsGroupLocationFeedbackReducer';
import meteorologyAgroCultureIndexAreaReducer from './meteorologyAgroCultureIndexAreaReducer';
import meteorologyAgroCultureIndexLocationReducer from './meteorologyAgroCultureIndexLocationReducer';
import meteorologyAgroTrackingForecastDetailedViewControlPanelReducer from './meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import meteorologyAgroOverviewPanelReducer from './meteorologyAgroOverviewPanelReducer';
import meteorologyAgroOverviewDashboardReducer from './meteorologyAgroOverviewDashboardReducer';
import similaridadeReducer from './similaridadeReducer';
import meteorologyFieldsModelPerformanceReducer from './meteorologyFieldsModelPerformanceReducer';
import windxControlPanelReducer from './windxControlPanelReducer';
import relatoriosDecompReducer from './relatoriosDecompReducer';
import relatoriosDessemReducer from './relatoriosDessemReducer';
import relatoriosIntersemanalReducer from './relatoriosIntersemanalReducer';
import relatoriosSemanalReducer from './relatoriosSemanalReducer';
import relatoriosMatrizReducer from './relatoriosMatrizReducer';
import relatoriosMensalReducer from './relatoriosMensalReducer';
import themeReducer from './themeReducer';

export default combineReducers({
  auth: authReducer,
  theme: themeReducer,
  infiniteScroll: infiniteScrollReducer,
  userModal: userModalReducer,
  mailerLayout: mailerLayoutReducer,
  nfeProcessing: nfeProcessingReducer,
  fileDownloads: fileDownloadsReducer,
  sendInvoiceModal: sendInvoiceModalReducer,
  productKeys: productKeyReducer,
  meteorologyFieldsLayout: meteorologyFieldsLayoutReducer,
  weatherLayout: weatherLayoutReducer,
  sidebars: sidebarsReducer,
  meteorologyFieldsComparatorControlPanel: meteorologyFieldsComparatorControlPanelReducer,
  meteorologyFieldsClassicComparatorControlPanel: meteorologyFieldsClassicComparatorReducer,
  meteorologyFieldsControlPanel: meteorologyFieldsControlPanelReducer,
  meteorologyFieldsObservedDataControlPanel: meteorologyFieldsObservedDataControlPanelReducer,
  savePreferencesModal: savePreferencesModalReducer,
  saveComparatorPreferencesModal: saveComparatorPreferencesModalReducer,
  imagesRowSize: imagesRowSizeReducer,
  flexUploadLayout: flexUploadLayoutReducer,
  fluxPersonalizedLayout: fluxPersonalizedLayoutReducer,
  fluxAutomaticControlPanel: fluxAutomaticControlPanelReducer,
  fluxAutomaticLayout: fluxAutomaticLayoutReducer,
  fluxUploadForm: fluxUploadFormReducer,
  verifyZipFileModal: verifyZipFileModalReducer,
  fluxPersonalizedForm: fluxPersonalizedFormReducer,
  fluxAutomaticPreferencesModal: fluxAutomaticPreferencesModalReducer,
  synopticChart: synopticChartsReducer,
  meteorologyWeatherSeasonalForecastControlPanel:
    meteorologyWeatherSeasonalForecastControlPanelReducer,
  meteorologyWeatherComparatorControlPanel:
    meteorologyWeatherComparatorControlPanelReducer,
  agroLayout: agroLayoutReducer,
  meteorologyAgroWBCulture: meteorologyAgroWBCultureReducer,
  meteorologyAgroWBSequentialMaps: meteorologyAgroWBSequentialMapsReducer,
  meteorologyAgroWBSequentialDV: meteorologyAgroWBSequentialDVReducer,
  meteorologyAgroGroupLocationFeedback: meteorologyAgroGroupLocationFeedbackReducer,
  meteorologyFieldsTrackingForecastControlPanel:
    meteorologyFieldsTrackingForecastControlPanelReducer,
  [baseApi.reducerPath]: baseApi.reducer,
  meteorologyFieldsGroupLocationFeedback: meteorologyFieldsGroupLocationFeedbackReducer,
  meteorologyAgroCultureIndexArea: meteorologyAgroCultureIndexAreaReducer,
  meteorologyAgroCultureIndexLocation: meteorologyAgroCultureIndexLocationReducer,
  meteorologyAgroTrackingForecastDetailedViewControlPanel:
    meteorologyAgroTrackingForecastDetailedViewControlPanelReducer,
  meteorologyAgroOverviewPanel:
    meteorologyAgroOverviewPanelReducer,
  meteorologyAgroOverviewDashboard: meteorologyAgroOverviewDashboardReducer,
  similaridade: similaridadeReducer,
  meteorologyFieldsModelPerformance: meteorologyFieldsModelPerformanceReducer,
  windxControlPanel: windxControlPanelReducer,
  relatoriosDecomp: relatoriosDecompReducer,
  relatoriosDessem: relatoriosDessemReducer,
  relatoriosIntersemanal: relatoriosIntersemanalReducer,
  relatoriosSemanal: relatoriosSemanalReducer,
  relatoriosMatriz: relatoriosMatrizReducer,
  relatoriosMensal: relatoriosMensalReducer,
});
